<template>
	<div class="main-business">
		
		<!-- ====== Hero 头部区域（300px） ====== -->
		<section class="mb-hero wow animate__fadeIn" data-wow-duration="0.8s">
			<div class="hero-bg-wrap">
				<el-image class="hero-bg-img" :src="require('@/static/CodeBuddyAssets/31164_2418/12.png')"></el-image>
			</div>
			<div class="hero-inner">
				<div class="hero-title-group">
					<h1 class="hero-title">{{$t('Business.t1')}}</h1>
					<div class="hero-deco">
						<span class="deco-line deco-left"></span>
						<p class="hero-subtitle">{{$t('Business.t2')}}</p>
						<span class="deco-line deco-right"></span>
					</div>
				</div>
			</div>
		</section>

		<!-- ====== 业务模块区域 ====== -->
		<div class="mb-content">

			<!-- 模块一：国际海运 -->
			<div class="biz-card wow animate__fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">
				<div class="card-wrap">
					<div class="card-text">
						<!-- 图标 -->
						<el-image class="sec-icon" :src="require('@/static/CodeBuddyAssets/31164_2418/6.svg')"></el-image>
						<!-- 标题徽章 -->
						<div class="title-badge">
							<el-image class="badge-bg" :src="require('@/static/CodeBuddyAssets/31164_2418/7.svg')"></el-image>
							<span class="badge-text">国际海运&nbsp;—&nbsp;海运整箱&nbsp;&nbsp;拼箱进出口</span>
						</div>
						<!-- 描述文字 -->
						<p class="desc-text">与全球28家船公司签定战略合作，提供全球整箱、拼箱进出口服务，主要航线，提供稳定的船期运价及舱位，享受充足的整拼箱订舱以及仓位，&nbsp;并保持客户服务的标准化和可靠性，同时慧承供应链还可以为客户提供报关等服务</p>
						<!-- 按钮 -->
						<button class="consult-btn">立即咨询</button>
					</div>
					<div class="card-img">
						<el-image :src="require('@/static/CodeBuddyAssets/31164_2418/16.png')"></el-image>
					</div>
				</div>
			</div>

			<!-- 模块二：清关（含浅蓝背景 #EFF5FB） -->
			<div class="biz-alt-bg wow animate__fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s">
				<div class="biz-card card-reverse">
					<div class="card-wrap card-wrap-rev">
						<div class="card-text card-text-rev">
							<!-- 图标 -->
							<el-image class="sec-icon" :src="require('@/static/CodeBuddyAssets/31164_2418/8.svg')"></el-image>
							<!-- 标题徽章 -->
							<div class="title-badge">
								<el-image class="badge-bg" :src="require('@/static/CodeBuddyAssets/31164_2418/11.svg')"></el-image>
								<span class="badge-text">清关&nbsp;—&nbsp;美加、欧洲、东南亚、澳新DDP/DDU</span>
							</div>
							<!-- 描述文字 -->
							<p class="desc-text">长期致力于世界各国服务&nbsp;,&nbsp;无论是个人还是公司，只需提供箱单发票，一口价一票收费，安排清关后直接按人指示预约送货，适用于DDU、DDP、LDP、&nbsp;&nbsp;EXW等各种国际贸易交易条款。</p>
							<!-- 按钮 -->
							<button class="consult-btn">立即咨询</button>
						</div>
						<div class="card-img">
							<el-image :src="require('@/static/CodeBuddyAssets/31164_2418/17.png')"></el-image>
						</div>
					</div>
				</div>
			</div>

			<!-- 模块三：国际空运 -->
			<div class="biz-card wow animate__fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.6s">
				<div class="card-wrap">
					<div class="card-text">
						<!-- 图标 -->
						<el-image class="sec-icon" :src="require('@/static/CodeBuddyAssets/31164_2418/8.svg')"></el-image>
						<!-- 标题徽章 -->
						<div class="title-badge">
							<el-image class="badge-bg" :src="require('@/static/CodeBuddyAssets/31164_2418/9.svg')"></el-image>
							<span class="badge-text">国际空运&nbsp;—&nbsp;高效、快捷的一站式专业物流商</span>
						</div>
						<!-- 描述文字 -->
						<p class="desc-text">已开通空运至北美、欧洲、日本、南美、非洲、澳洲等空运专线，&nbsp;同时可根据客户需要将货物单独安排航班空运，并代理目的地的清关、本地派送等事宜，&nbsp;将货物安全的送达</p>
						<!-- 按钮 -->
						<button class="consult-btn">立即咨询</button>
					</div>
					<div class="card-img">
						<el-image :src="require('@/static/CodeBuddyAssets/31164_2418/15.png')"></el-image>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: 'MainBusiness',
	mounted() {
		if (this.$wow) {
			this.$wow.init()
		}
	}
}
</script>

<style lang="scss" scoped>
.main-business {
	width: 100%;
	min-height: 100vh;
	background: #fff;
	position: relative;
}

/* ============================================================
   Hero 头部 — 300px
   ============================================================ */
.mb-hero {
	position: relative;
	width: 100%;
	height: 3.00rem;
	background: #0096FF;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
}
.hero-bg-wrap {
	position: absolute;
	inset: 0;
	z-index: 1;
	.hero-bg-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
}
.hero-inner {
	position: relative;
	z-index: 2;
	display: flex;
	justify-content: center;
	transform: translateY(12px);
}
.hero-title-group {
	display: flex;
	flex-direction: column;
	align-items: center;
	// width: 5.04rem;
	// padding-top: 202rpx;
}
.hero-title {
	font-size: 0.62rem;
	font-weight: 600;
	font-family: 'PingFang SC', sans-serif;
	color: #fff;
	text-align: center;
	margin: 0;
	line-height: 1.2;
	letter-spacing: 0.02em;
	position: relative;
	left: 0.27rem;
}
.hero-deco {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 0.20rem;
	width: 100%;
	position: relative;
}
.deco-line {
	width: 0.82rem;
	height: 0.02rem;
	flex-shrink: 0;
}
.deco-left {
	background: linear-gradient(90deg, rgba(255,255,255,0) 0%, #fff 100%);
}
.deco-right {
	background: linear-gradient(90deg, rgba(255,255,255,0) 0%, #fff 100%);
	transform: rotate(180deg);
}
.hero-subtitle {
	font-size: 0.20rem;
	font-weight: 500;
	font-family: 'PingFang SC', sans-serif;
	color: #fff;
	margin: 0 0.18rem;
	white-space: nowrap;
	letter-spacing: 0.02em;
}

/* ============================================================
   业务模块区域
   ============================================================ */
.mb-content {
	padding-bottom: 0.60rem;
	background: #fff;
}

/* ---- 卡片通用 ---- */
.biz-card {
	width: 13.36rem;
	margin: 0 auto;
}
.card-wrap {
	display: flex;
	align-items: stretch;
	gap: 0.71rem;
	min-height: 4.44rem;
}

/* ---- 卡片一（海运）：52px 上间距 ---- */
.biz-card:nth-of-type(1) {
	padding-top: 0.52rem;
}

/* ---- 卡片二（清关）背景区域 ---- */
.biz-alt-bg {
	width: 100%;
	background: #EFF5FB;
	padding: 0.60rem 0;
	margin-top: 0.52rem;
}
.biz-alt-bg .biz-card {
	margin: 0 auto;
}
.card-wrap-rev {
	flex-direction: row-reverse;
}

/* ---- 卡片三（空运）：60px 上间距 ---- */
.biz-card:nth-of-type(3) {
	margin-top: 0.60rem;
}

/* ---- 左侧文字区 ---- */
.card-text {
	flex: 0 0 7.55rem;
	display: flex;
	flex-direction: column;
	position: relative;
	// padding-top: 0.50rem;
}
.card-text-rev {
	flex: 0 0 7.48rem;
}

/* 图标 */
.sec-icon {
	width: 0.44rem;
	height: 0.44rem;
	object-fit: contain;
	flex-shrink: 0;
	margin-bottom: 0.14rem;
	margin-left: 0.08rem;
	margin-top: 0.10rem;
}

/* 标题徽章 */
.title-badge {
	display: flex;
	align-items: center;
	height: 0.39rem;
	margin-bottom: 0.12rem;
	position: relative;
}
.badge-bg {
	height: 100%;
	width: auto;
}
.badge-text {
	font-size: 0.22rem;
	font-weight: 500;
	font-family: 'PingFang SC', sans-serif;
	color: #0096FF;
	margin-left: 0.08rem;
	white-space: nowrap;
}

/* 描述文字 */
.desc-text {
	font-size: 0.20rem;
	font-weight: 400;
	font-family: 'PingFang SC', sans-serif;
	color: #626780;
	line-height: 1.7;
	margin: 0 0 0.28rem;
	padding-left: 0.08rem;
}
.desc-text:last-of-type {
	margin-bottom: 0.44rem;
}

/* 咨询按钮 */
.biz-card .consult-btn {
	width: 1.84rem;
	height: 0.60rem;
	background: #0096FF;
	border: none;
	border-radius: 0.10rem;
	color: #fff;
	font-size: 0.18rem;
	font-weight: 500;
	font-family: 'PingFang SC', sans-serif;
	cursor: pointer;
	transition: all 0.3s ease;
	flex-shrink: 0;
	margin-left: 0.08rem;
	&:hover {
		background: #0078d7;
		transform: translateY(-0.04rem) scale(1.05);
		box-shadow: 0 0.08rem 0.24rem rgba(0,150,255,0.35);
		animation: animate__heartBeat 0.8s ease-in-out;
	}
}

/* ---- 右侧图片区 (animate.css hover效果) ---- */
.biz-card .card-img {
	width: 5.10rem;
	flex-shrink: 0;
	overflow: hidden;
	::v-deep .el-image {
		width: 100%;
		height: 4.44rem;
		object-fit: cover;
		display: block;
		transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
		&:hover {
			transform: scale(1.08);
		}
	}
}

/* ============================================================
   Hover 动画效果 (animate.css)
   ============================================================ */

/* 图标 hover - 弹跳效果 */
.biz-card .sec-icon {
	transition: transform 0.3s ease;
	&:hover {
		animation: animate__bounceIn 0.8s ease;
		transform: scale(1.15);
	}
}

/* 标题徽章 hover - 脉冲效果 */
.biz-card .title-badge {
	transition: transform 0.3s ease;
	&:hover {
		animation: animate__pulse 0.6s ease;
		transform: scale(1.03);
	}
}

/* 描述文字 hover - 淡入上滑 + 颜色变化 */
.biz-card .desc-text {
	transition: color 0.3s ease, transform 0.3s ease;
	&:hover {
		color: #0096FF;
		animation: animate__fadeInUp 0.5s ease;
		transform: translateX(0.05rem);
	}
}

/* ============================================================
   响应式
   ============================================================ */
@media screen and (max-width: 1440px) {
	.biz-card { width: 92%; }
	.card-wrap { gap: 0.40rem; }
	.card-text { flex: 0 0 60%; padding-top: 0.30rem; }
	.card-text-rev { flex: 0 0 60%; }
	.card-img { width: 40%; }
	.card-img img { height: auto; }
	.hero-title { font-size: 0.50rem; left: 0.20rem; }
	.desc-text { font-size: 0.17rem; }
	.badge-text { font-size: 0.19rem; }
}
</style>
